var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReachIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.471,
    height: 140.631,
    viewBox: "0 0 114.471 140.631",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PrEhwJ.tif",
    transform: "translate(-881.962 -1687.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2232",
    "data-name": "Group 2232",
    transform: "translate(883.797 1689.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3600",
    "data-name": "Path 3600",
    d: "M965.42,1761.573c-.558,11.191-16.353,10.767-16.885,0C949.093,1750.382,964.888,1750.807,965.42,1761.573Z",
    transform: "translate(-901.47 -1706.618)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    "data-name": "Path 3601",
    d: "M957.946,1770.547c-17.324-27.684-9.578,49.026-11.1,52.337-3.146-11.688-24.007-17.922-10.7.816,4.587,8.441,3.842,18.545,16.536,21.768,42.236,8.573,31.29-21.548,32.7-34.472,1.569-8.225-5.837-15.578-9.457-4.819,2.718-10.543-6.811-19.331-9.433-7.155,2.364-10.039-6.565-18.28-7.969-5.109C957.663,1785.965,957.947,1779.049,957.946,1770.547Z",
    transform: "translate(-896.889 -1709.674)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2224",
    "data-name": "Group 2224",
    transform: "translate(0 58.372)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    y1: 11.261,
    x2: 42.346,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2225",
    "data-name": "Group 2225",
    transform: "translate(68.455 58.372)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x1: 42.346,
    y1: 11.261,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2226",
    "data-name": "Group 2226",
    transform: "translate(0.056 39.431)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 42.201,
    y2: 11.792,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2227",
    "data-name": "Group 2227",
    transform: "translate(68.527 39.431)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 42.201,
    y2: 11.792,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2228",
    "data-name": "Group 2228",
    transform: "translate(65.072 13.928)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    x1: 30.963,
    y2: 31.005,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2229",
    "data-name": "Group 2229",
    transform: "translate(14.64 13.928)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 30.963,
    y2: 31.005,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2230",
    "data-name": "Group 2230",
    transform: "translate(40.773)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 11.936,
    y2: 42.161,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2231",
    "data-name": "Group 2231",
    transform: "translate(58.652)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x1: 11.936,
    y2: 42.161,
    fill: "none",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3602",
    "data-name": "Path 3602",
    d: "M1011.273,1778.247c.2,7.446,11.445,8.058,12.068,0C1023.145,1770.8,1011.9,1770.19,1011.273,1778.247Z",
    transform: "translate(-918.596 -1711.83)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    d: "M1007.389,1746.831c.2,7.446,11.445,8.057,12.068,0C1019.261,1739.385,1008.012,1738.774,1007.389,1746.831Z",
    transform: "translate(-917.536 -1703.254)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    d: "M990.408,1723.255c.2,7.446,11.446,8.058,12.068,0C1002.281,1715.809,991.031,1715.2,990.408,1723.255Z",
    transform: "translate(-912.9 -1696.818)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    d: "M964.307,1714.184c.2,7.445,11.445,8.057,12.068,0C976.179,1706.738,964.93,1706.127,964.307,1714.184Z",
    transform: "translate(-905.775 -1694.341)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M939.516,1714.92c.2,7.446,11.445,8.058,12.068,0C951.388,1707.474,940.139,1706.862,939.516,1714.92Z",
    transform: "translate(-899.008 -1694.542)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    "data-name": "Path 3607",
    d: "M912.782,1723.22c.2,7.446,11.445,8.058,12.068,0C924.654,1715.774,913.405,1715.163,912.782,1723.22Z",
    transform: "translate(-891.71 -1696.808)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    "data-name": "Path 3608",
    d: "M895.988,1746.831c.2,7.446,11.445,8.057,12.068,0C907.86,1739.385,896.611,1738.774,895.988,1746.831Z",
    transform: "translate(-887.125 -1703.254)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3609",
    "data-name": "Path 3609",
    d: "M891.524,1778.247c.2,7.446,11.445,8.058,12.068,0C903.4,1770.8,892.147,1770.19,891.524,1778.247Z",
    transform: "translate(-885.907 -1711.83)",
    stroke: "#ef7b13",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReachIcon);
export default __webpack_public_path__ + "static/media/reach-icon.17a072a927a55fbd0b3c9abf4557f9e9.svg";
export { ForwardRef as ReactComponent };